import ReactDOM from "react-dom/client";
import "./index.css";
import AppRouter from "./routes/app-router.tsx";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { OverlayProvider } from "overlay-kit";
import { Toaster } from "./components/ui/sonner.tsx";
import "./i18n";
import * as Sentry from "@sentry/react";
// 공통 Sentry 설정
Sentry.init({
  dsn: import.meta.env.VITE_APP_SENTRY_DSN,
  environment: "production",
  initialScope: {
    tags: {
      server: import.meta.env.VITE_APP_SERVER_NAME,
      region: import.meta.env.VITE_APP_REGION,
    },
  },
  beforeSend(event) {
    // 추가로 서버 정보를 컨텍스트에 추가
    event.contexts = {
      ...event.contexts,
      server: {
        name: import.meta.env.VITE_APP_SERVER_NAME,
        region: import.meta.env.VITE_APP_REGION,
      },
    };
    return event;
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: 24 * 60 * 60 * 1000,
      retry: 0,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>

  <QueryClientProvider client={queryClient}>
    <OverlayProvider>
      <AppRouter />
      {/* 테스트 환경에서는 DevTools 비활성화 */}
      {!window.navigator.webdriver &&
        process.env.NODE_ENV !== "test" &&
        !document.documentElement.hasAttribute("data-playwright") && (
          <ReactQueryDevtools
            initialIsOpen={false}
            buttonPosition="bottom-left"
          />
        )}
      <Toaster position="bottom-right" />
    </OverlayProvider>
  </QueryClientProvider>
  // </React.StrictMode>
);
